import { render, staticRenderFns } from "./OrderNotifyConfig.vue?vue&type=template&id=09b074dc&"
import script from "./OrderNotifyConfig.vue?vue&type=script&lang=js&"
export * from "./OrderNotifyConfig.vue?vue&type=script&lang=js&"
import style0 from "./OrderNotifyConfig.vue?vue&type=style&index=0&id=09b074dc&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports